module.exports = __webpack_public_path__ + "static/img/user.92ac64ac.png";